import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { DatasetDownload } from "./DatasetDownload";
import { Citation } from "./Citation";

export default function DrawerChildren() {

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "inherit" }}>
            <Box sx={{ flexGrow: 1, m: 2 }}>
                <Typography variant='h6'>
                    Description
                </Typography>
                <Typography variant='body2' color="text.secondary">
                    The Index of Connectivity (IC) quantifies the strength of linkage between a
                    point on a landscape and a downstream waterbody, such as a stream or lake. Here,
                    we display IC results modeled at the HUC-6 basin level. To download an IC
                    raster, first select an area of interest using the map interface. Thereafter,
                    select between 90-m, 30-m, and 10-m raster resolutions. Note that depending on
                    basin size and raster resolution, file sizes can range for a few MBs to several
                    GBs.
                    <br />
                    <br />
                    If you have questions or want to collaborate, please contact Admin Husic (<a href="mailto:ahusic@ku.edu">ahusic@ku.edu</a>).
                    <br />
                    <br />
                    <DatasetDownload />
                </Typography>
            </Box>
            {/* TODO: add section with information about sources */}
            {/* TODO: add link to hydroshare resource */}
            {/* TODO: add CUAHSI logo / watermark somewhere */}
            <Box sx={{ flexGrow: 1 }}>
                <Divider sx={{ mb: 2, ml: 0, mr: 0 }} />
                {/* Manuscript citation */}
                <Citation />
                {/* <br />
                Webapp created and hosted by <a href="https://www.cuahsi.org/"> CUAHSI</a>. */}
            </Box>
        </Box >
    )
}
